"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class Address {
  static thaw(addressObj) {
    if (addressObj == null) return null;
    const address = new Address();
    if (addressObj.id != null) address.setId(addressObj.id);
    if (addressObj.line1 != null) address.setLine1(addressObj.line1);
    if (addressObj.line2 != null) address.setLine2(addressObj.line2);
    if (addressObj.city != null) address.setCity(addressObj.city);
    if (addressObj.state != null) address.setState(addressObj.state);
    if (addressObj.zip != null) address.setZip(addressObj.zip);
    return address;
  }

  static thawList(addressObjList) {
    if (addressObjList == null) return [];
    var addresses = [];

    for (var i = 0; i < addressObjList.length; i++) {
      addresses.push(Address.thaw(addressObjList[i]));
    }

    return addresses;
  }

  static freeze(address) {
    if (address == null) return null;
    var addressObj = {};
    if (address.getId() != null) addressObj.id = address.getId();
    if (address.getLine1() != null) addressObj.line1 = address.getLine1();
    if (address.getLine2() != null) addressObj.line2 = address.getLine2();
    if (address.getCity() != null) addressObj.city = address.getCity();
    if (address.getState() != null) addressObj.state = address.getState();
    if (address.getZip() != null) addressObj.zip = address.getZip();
    return addressObj;
  }

  static freezeList(addresses) {
    if (addresses == null) return [];
    var addressObjList = [];

    for (var i = 0; i < addresses.length; i++) {
      addressObjList.push(Address.freeze(addresses[i]));
    }

    return addressObjList;
  }

  constructor() {
    this.setId(null);
    this.setLine1(null);
    this.setLine2(null);
    this.setCity(null);
    this.setState(null);
    this.setZip(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setLine1(line1) {
    this.line1 = line1;
  }

  setLine2(line2) {
    this.line2 = line2;
  }

  setCity(city) {
    this.city = city;
  }

  setState(state) {
    this.state = state;
  }

  setZip(zip) {
    this.zip = zip;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getLine1() {
    return this.line1;
  }

  getLine2() {
    return this.line2;
  }

  getCity() {
    return this.city;
  }

  getState() {
    return this.state;
  }

  getZip() {
    return this.zip;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


  getCityStateZip() {
    return this.city + ', ' + this.state + ' ' + this.zip;
  }

  getFullAddress() {
    return this.line2 ? this.line1 + ' ' + this.line2 + ' ' + this.getCityStateZip() : this.line1 + ' ' + this.getCityStateZip();
  }

}

exports.default = Address;